class WyzePdpPopupModal {
	constructor(container) {
		this.container = container;
		this.productDataJSON = JSON.parse(container.querySelector('[data-product-json]').innerHTML)
		this.productMetafieldsDataJSON = JSON.parse(container.querySelector('[data-product-metafields-json]').innerHTML)
		this.productForm = this.container.querySelector(`#product-form-${this.container.dataset.section}`);
		this.idInput = this.productForm.querySelector('input[name="id"]');
		this.currentVariant = this.idInput.value;
		this.productColorPackSize = variantMetafields[this.currentVariant] ? variantMetafields[this.currentVariant].variant_option_string : '';
		this.mediaGallery = this.container.querySelectorAll('.product__media-image');
		this.media = this.productDataJSON.media;
		this.isUsingKeyboard = false;
		this.modal = null;
		this.focusableElements = 'a:not([disabled]), button:not([disabled]), textarea:not([disabled]), input[type="text"]:not([disabled]), input[type="radio"]:not([disabled]), input[type="checkbox"]:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])';
		this.lastFocusedElement = null;

		this.init();
	}

	init() {
		this.createModal();
		this.filterMedia();
		this.generateTabContent();
		this.setupEventListeners();
	}

	filterMedia() {
		this.images = this.media.filter(item => item.media_type === 'image');
		this.videos = this.media.filter(item => item.media_type === 'video' || item.media_type === 'external_video');
	}

	createModal() {
		this.modal = document.createElement('div');
		this.modal.classList.add('wyze-pdp-popup-modal');
		this.modal.innerHTML = `
			<div class="wyze-pdp-popup-modal__content">
				<div class="wyze-pdp-popup-modal__body">
					<div class="wyze-pdp-popup-modal__tabs-buttons">
						<button class="wyze-pdp-popup-modal__tab-button wyze-pdp-popup-modal__tab-button--images active" data-tab="images">Images (<span class="wyze-pdp-popup-modal__tab-button--images-count"></span>)</button>
						<button class="wyze-pdp-popup-modal__tab-button wyze-pdp-popup-modal__tab-button--videos" data-tab="videos">Videos (<span class="wyze-pdp-popup-modal__tab-button--videos-count"></span>)</button>
						<button class="wyze-pdp-popup-modal__close" aria-label="Close modal">
							<svg
								xmlns="http://www.w3.org/2000/svg"
								aria-hidden="true"
								focusable="false"
								class="icon icon-close"
								fill="none"
								viewBox="0 0 18 17"
							>
								<path d="M.865 15.978a.5.5 0 00.707.707l7.433-7.431 7.579 7.282a.501.501 0 00.846-.37.5.5 0 00-.153-.351L9.712 8.546l7.417-7.416a.5.5 0 10-.707-.708L8.991 7.853 1.413.573a.5.5 0 10-.693.72l7.563 7.268-7.418 7.417z" fill="currentColor">
							</svg>
						</button>
					</div>
					<div class="wyze-pdp-popup-modal__tabs">
						<div class="wyze-pdp-popup-modal__tab wyze-pdp-popup-modal__images active">
							<div class="wyze-pdp-popup-modal__featured">
							<button
							  data-popup-modal-button="images"
							  data-direction="prev"
                              type="button"
                              class="slider-button slider-button--prev"
                              name="previous"
                              aria-label="Previous slide"
                            >
								<svg aria-hidden="true" focusable="false" class="icon icon-caret" viewBox="0 0 10 6">
									<path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor">
								</svg>
                            </button>
							<button
							  data-popup-modal-button="images"
							  data-direction="next"
                              type="button"
                              class="slider-button slider-button--next"
                              name="next"
                              aria-label="Next slide"
                            >
								<svg aria-hidden="true" focusable="false" class="icon icon-caret" viewBox="0 0 10 6">
									<path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor">
								</svg>
                            </button>
							<div class="wyze-pdp-popup-modal__images-featured"></div>
							</div>
							<div class="wyze-pdp-popup-modal__grid-container">
								<h2 class="wyze-pdp-popup-modal__grid-title">${this.productDataJSON.title}${this.productMetafieldsDataJSON.feedTitleFeatures ? ` - ${this.productMetafieldsDataJSON.feedTitleFeatures}` : ''}</h2>
								<span class="wyze-pdp-popup-modal__grid-subtitle">${this.productColorPackSize || ''}</span>
								<div class="wyze-pdp-popup-modal__grid wyze-pdp-popup-modal__images-grid"></div>
							</div>
						</div>
						<div class="wyze-pdp-popup-modal__tab wyze-pdp-popup-modal__videos">
							<div class="wyze-pdp-popup-modal__featured wyze-pdp-popup-modal__videos-featured">
								<button
								data-popup-modal-button="videos"
								data-direction="prev"
								type="button"
								class="slider-button slider-button--prev"
								name="previous"
								aria-label="Previous slide"
								>
									<svg aria-hidden="true" focusable="false" class="icon icon-caret" viewBox="0 0 10 6">
										<path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor">
									</svg>
								</button>
								<button
								data-popup-modal-button="videos"
								data-direction="next"
								type="button"
								class="slider-button slider-button--next"
								name="next"
								aria-label="Next slide"
								>
									<svg aria-hidden="true" focusable="false" class="icon icon-caret" viewBox="0 0 10 6">
										<path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor">
									</svg>
								</button>
							<div class="wyze-pdp-popup-modal__videos-featured"></div>
							</div>
							<div class="wyze-pdp-popup-modal__grid-container">
								<h2 class="wyze-pdp-popup-modal__grid-title">${this.productDataJSON.title}${this.productMetafieldsDataJSON.feedTitleFeatures ? ` - ${this.productMetafieldsDataJSON.feedTitleFeatures}` : ''}</h2>
								<span class="wyze-pdp-popup-modal__grid-subtitle">${this.productColorPackSize || ''}</span>
								<div class="wyze-pdp-popup-modal__grid wyze-pdp-popup-modal__videos-grid"></div>
							</div>
						</div>
					</div>
				</div>
				<div class="wyze-pdp-popup-modal__overlay"></div>
			</div>
			<div id="change-announcement" aria-live="polite" class="visually-hidden"></div>
		`;
		this.container.appendChild(this.modal);
	}

	generateTabContent() {
		this.populateImageTab();
		this.populateVideoTab();
	}

	populateImageTab() {
		const imagesButton = this.modal.querySelector('.wyze-pdp-popup-modal__tab-button--images');
		const imagesCount = this.modal.querySelector('.wyze-pdp-popup-modal__tab-button--images-count');
		const imagesFeatured = this.modal.querySelector('.wyze-pdp-popup-modal__images-featured');
		const imagesGrid = this.modal.querySelector('.wyze-pdp-popup-modal__images-grid');

		imagesCount.textContent = this.images.length;

		if (this.images.length === 0) {
			imagesButton.classList.add('hidden');
			return;
		}

		const firstImage = this.images[0];
		imagesFeatured.innerHTML = `
			<img id="wyze-pdp-popup-modal__featured-images" src="${firstImage.preview_image.src}" alt="${firstImage.alt || ''}" width="${firstImage.width}" height="${firstImage.height}" class="wyze-pdp-popup-modal__featured-images">
		`;

		imagesGrid.innerHTML += this.images.map((image, index) => `
			<button class="wyze-pdp-popup-modal__grid-item ${index === 0 ? 'active' : ''}" data-position="${image.position}" data-type="images" aria-controls="wyze-pdp-popup-modal__featured-images">
				<img src="${image.preview_image.src}" alt="${image.alt || ''}" width="88" height="88" class="wyze-pdp-popup-modal__grid-image">
			</button>
		`).join('');
	}

	populateVideoTab() {
		const videosButton = this.modal.querySelector('.wyze-pdp-popup-modal__tab-button--videos');
		const videosCount = this.modal.querySelector('.wyze-pdp-popup-modal__tab-button--videos-count');
		const videosFeatured = this.modal.querySelector('.wyze-pdp-popup-modal__videos-featured');
		const videosGrid = this.modal.querySelector('.wyze-pdp-popup-modal__videos-grid');

		videosCount.textContent = this.videos.length;

		if (this.videos.length === 0) {
			videosButton.classList.add('hidden');
			return;
		}

		let iframe = '';

		const firstVideo = this.videos[0];

		if (firstVideo.host === 'youtube') {
			iframe = `
				<iframe frameborder="0" allow="autoplay; encrypted-media" allowfullscreen src="https://www.youtube.com/embed/${firstVideo.external_id}?enablejsapi=1" title="${firstVideo.alt || 'Video'}"></iframe>
			`;
		} else if (firstVideo.host === 'vimeo') {
			iframe = `
				<iframe frameborder="0" allow="autoplay; encrypted-media" allowfullscreen src="https://player.vimeo.com/video/${firstVideo.external_id}" title="${firstVideo.alt || 'Video'}"></iframe>
			`;
		}

		videosFeatured.innerHTML = `
			<div id="wyze-pdp-popup-modal__featured-videos" class="wyze-pdp-popup-modal__featured-videos">
				${iframe}
			</div>
		`;

		videosGrid.innerHTML = this.videos.map((video, index) => `
			<button class="wyze-pdp-popup-modal__grid-item ${index === 0 ? 'active' : ''}" data-position="${video.position}" data-type="videos" aria-controls="wyze-pdp-popup-modal__featured-videos">
				<img src="${video.preview_image.src}" alt="${video.alt || ''}" class="wyze-pdp-popup-modal__grid-video">
			</button>
		`).join('');
	}

	setupEventListeners() {
		// Query selectors
		const closeButton = this.modal.querySelector('.wyze-pdp-popup-modal__close');
		const overlay = this.modal.querySelector('.wyze-pdp-popup-modal__overlay');
		const tabButtons = this.modal.querySelectorAll('.wyze-pdp-popup-modal__tab-button');
		const imageGridItems = this.modal.querySelectorAll('.wyze-pdp-popup-modal__images-grid .wyze-pdp-popup-modal__grid-item');
		const videoGridItems = this.modal.querySelectorAll('.wyze-pdp-popup-modal__videos-grid .wyze-pdp-popup-modal__grid-item');
		const gridNavButtons = [...this.modal.querySelectorAll('[data-popup-modal-button]')];

		gridNavButtons.forEach((button) => {
			const direction = button.dataset.direction;
			const type = button.dataset.popupModalButton;
			let grid = imageGridItems;
			if(type == 'videos') grid = videoGridItems;
			if(grid.length < 2) button.classList.add('hidden');

			button.addEventListener('click', () => this.handleGridNavButton(direction, type, grid, this));
		});

		// Close button and overlay
		closeButton.addEventListener('click', () => this.closeModal());
		overlay.addEventListener('click', () => this.closeModal());

		// Gallery images that open the modal
		this.mediaGallery.forEach(media => {
			media.addEventListener('click', (e) => this.openModal(e));
		});

		// Tab switching
		tabButtons.forEach(button => {
			button.addEventListener('click', (e) => {
				// Use closest to handle clicks on child elements (like the count span)
				const tabButton = e.target.closest('.wyze-pdp-popup-modal__tab-button');
				if (tabButton) {
					this.switchTab(tabButton.dataset.tab);
				}
			});
		});

		// Image grid clicks
		imageGridItems.forEach(item => {
			item.addEventListener('click', () => this.handleGridClick(item, 'images'));
		});

		// Video grid clicks
		videoGridItems.forEach(item => {
			item.addEventListener('click', () => this.handleGridClick(item, 'videos'));
		});

		// Keyboard navigation
		this.modal.addEventListener('keydown', (e) => this.handleKeydown(e));

		this.idInput.addEventListener('change', (e) => this.handleInputChange(e));
	}

	handleGridNavButton(direction, type, grid, that){
		const active = that.modal.querySelector('.wyze-pdp-popup-modal__grid-item.active');
		let index = [...grid].indexOf(active);

		if(direction == 'prev'){
			if((index - 1) < 0) {
				index = [...grid].length - 1
			} else index -= 1;
		} else {
			if((index + 1) > ([...grid].length - 1)) {
				index = 0
			} else index += 1;
		};

		const item = grid[index];

		that.handleGridClick(item, type);
	};

	switchTab(tabName) {
		if (!tabName) return;

		const allTabs = this.modal.querySelectorAll('.wyze-pdp-popup-modal__tab');
		const allButtons = this.modal.querySelectorAll('.wyze-pdp-popup-modal__tab-button');

		allTabs.forEach(tab => tab.classList.remove('active'));
		allButtons.forEach(button => button.classList.remove('active'));

		const activeTab = this.modal.querySelector(`.wyze-pdp-popup-modal__${tabName}`);
		const activeButton = this.modal.querySelector(`[data-tab="${tabName}"]`);

		if (activeTab && activeButton) {
			activeTab.classList.add('active');
			activeButton.classList.add('active');
		}
	}

	openModal(e) {
		if (!e.target.classList.contains('image-magnify-modal')) return;
		const media = this.modal.querySelector(`.wyze-pdp-popup-modal__grid-item[data-position="${e.target.dataset.modalPosition}"]`);
		this.handleGridClick(media, media.dataset.type);
		this.switchTab(media.dataset.type)
		this.lastFocusedElement = document.activeElement;
		this.modal.classList.add('active');
		document.body.classList.add('overflow-hidden');
		this.focusFirstElement();
	}

	closeModal() {
		this.modal.classList.remove('active');
		document.body.classList.remove('overflow-hidden');

		// Restore focus to the element that opened the modal
		if (this.lastFocusedElement) {
			this.lastFocusedElement.focus();
			this.lastFocusedElement = null;
		}
	}

	focusFirstElement() {
		const focusableContent = this.modal.querySelectorAll(this.focusableElements);
		if (focusableContent.length > 0) {
			focusableContent[0].focus();
		}
	}

	handleKeydown(e) {
		// Close modal on Escape or Enter key
		if (e.key === 'Escape' || e.key === 'Enter') {
			e.preventDefault();
			this.closeModal();
			return;
		}

		// Trap focus inside modal with Tab key
		if (e.key === 'Tab') {
			this.trapFocus(e);
		}
	}

	trapFocus(e) {
		const focusableContent = Array.from(this.modal.querySelectorAll(this.focusableElements));
		const firstElement = focusableContent[0];
		const lastElement = focusableContent[focusableContent.length - 1];

		// If shift+tab on first element, focus last element
		if (e.shiftKey && document.activeElement === firstElement) {
			e.preventDefault();
			lastElement.focus();
		}
		// If tab on last element, focus first element
		else if (!e.shiftKey && document.activeElement === lastElement) {
			e.preventDefault();
			firstElement.focus();
		}
	}

	handleGridClick(clickedItem, type) {
		const announcementRegion = this.container.querySelector('#change-announcement')
		const position = clickedItem.dataset.position;
		if (!position) return;

		// Get the appropriate media array
		const mediaArray = type === 'images' ? this.images : this.videos;
		const mediaData = mediaArray.find(item => item.position == position);
		if (!mediaData) return;

		// Update active state in grid
		const allGridItems = this.modal.querySelectorAll(`.wyze-pdp-popup-modal__${type}-grid .wyze-pdp-popup-modal__grid-item`);
		allGridItems.forEach(item => item.classList.remove('active'));
		clickedItem.classList.add('active');

		const featured = this.modal.querySelector(`.wyze-pdp-popup-modal__${type}-featured`);

		if (type === 'images') {
			// Preload image before swapping to reduce flicker
			const img = new Image();

			img.onload = () => {
				featured.innerHTML = `
					<img id="wyze-pdp-popup-modal__featured-${type}" src="${mediaData.preview_image.src}" alt="${mediaData.alt || 'No description'}" width="${mediaData.width}" height="${mediaData.height}" class="wyze-pdp-popup-modal__featured-${type}">
				`;
				announcementRegion.textContent = `Main image updated: "${mediaData.alt || 'No description'}"`;
			};

			img.src = mediaData.preview_image.src;
		} else {
			// Handle video iframe rendering
			let iframe = '';

			if (mediaData.host === 'youtube') {
				iframe = `
					<iframe frameborder="0" allow="autoplay; encrypted-media" allowfullscreen src="https://www.youtube.com/embed/${mediaData.external_id}?enablejsapi=1" title="${mediaData.alt || 'Video'}"></iframe>
				`;
			} else if (mediaData.host === 'vimeo') {
				iframe = `
					<iframe frameborder="0" allow="autoplay; encrypted-media" allowfullscreen src="https://player.vimeo.com/video/${mediaData.external_id}" title="${mediaData.alt || 'Video'}"></iframe>
				`;
			}

			featured.innerHTML = `
				<div id="wyze-pdp-popup-modal__featured-${type}" class="wyze-pdp-popup-modal__featured-${type}">
					${iframe}
				</div>
			`;
			announcementRegion.textContent = `Main video updated: "${mediaData.alt || 'No description'}"`;
		}
	}

	handleInputChange(e) {
		const newVariant = e.target.value;
		if (this.currentVariant === newVariant) return;

		this.currentVariant = newVariant;
		this.productColorPackSize = variantMetafields[this.currentVariant] ? variantMetafields[this.currentVariant].variant_option_string : '';

		// Update color/pack/size subtitle
		const subtitles = this.modal.querySelectorAll('.wyze-pdp-popup-modal__grid-subtitle');
		subtitles.forEach(subtitle => {
			subtitle.textContent = this.productColorPackSize || '';
		});
	}
}

document.addEventListener('DOMContentLoaded', () => {
	const container = document.querySelector('[data-wyze-product]');
	new WyzePdpPopupModal(container);
});